// The quick delete buttons (tournaments, puzzles, waiting matches) are only for the
// site owner's own accounts; the server checks the same list.
const OWNER_LOGIN_IDS = new Set(["yosdel", "yosdelledsoy@gmail.com", "yosdeledsoy@gmail.com"]);

export const isOwnerAccount = (user) =>
  [user?.loginIdentifier, user?.email, user?.username]
    .map((value) => String(value || "").trim().toLowerCase())
    .some((value) => OWNER_LOGIN_IDS.has(value));
